import { AppEntities } from "../../../../config/entities";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const CashboxesList = () => {
    const fields = [
        { title: "Name", fieldName: "name" },
    ];

    return (
        <>
            <NewCatalogListView fields={fields} entity={AppEntities.Cashboxes} />
        </>
    );
}

export default CashboxesList;

